import {
  OreCardActions,
  OreCardContainer,
  OreCardWrapper,
  OreStack,
} from '@edenredespana/oreneta'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Step2Actions, Step2Form, Step2Resume } from '@/Contract/ui/atoms'
import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { ProtectedWrapper } from '@/Shared/ui/navigation'

export const ChangeBankAccountStep2 = (): JSX.Element => {
  const { t } = useTranslation()
  const { confirmationForm } = useBankAccount()

  return (
    <ProtectedWrapper
      title={t(contractTranslation.changeBankAccount.modal.title)}
      description={t(contractTranslation.changeBankAccount.modal.description)}
    >
      <FormProvider {...confirmationForm}>
        <form>
          <OreStack placeContent="stretch" space="large">
            <Step2Resume />
            <OreCardContainer>
              <OreCardWrapper>
                <Step2Form />
              </OreCardWrapper>
              <OreCardActions>
                <Step2Actions />
              </OreCardActions>
            </OreCardContainer>
          </OreStack>
        </form>
      </FormProvider>
    </ProtectedWrapper>
  )
}
